import { useState } from "react";
import { toast } from "sonner";
import { Images } from "lucide-react";
import MediaCard from "@/components/media/MediaCard";

const KINDS = [["all", "Tous"], ["photo", "Photos"], ["video", "Vidéos"], ["youtube", "YouTube"], ["missing", "Manquants"]];

export default function MediaLibrary({ api, items, themes, missing, onChange }) {
  const [kind, setKind] = useState("all");
  const [theme, setTheme] = useState("Toutes");

  const shown = items.filter(
    (m) =>
      (theme === "Toutes" || m.theme === theme) &&
      (kind === "all" || (kind === "missing" ? missing.includes(m.id) : m.kind === kind))
  );

  const act = async (fn, msg) => {
    try {
      await fn();
      if (msg) toast.success(msg);
      onChange();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Action impossible.");
    }
  };

  const chip = (active) =>
    `rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors duration-300 ${active ? "bg-[#1C1917] text-[#FAF8F5]" : "border border-stone-300 text-stone-500 hover:border-[#C5A059]"}`;

  return (
    <section data-testid="media-library" className="mt-6 rounded-2xl border border-stone-200/80 bg-white p-5 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-display text-lg font-semibold text-stone-900">Médiathèque <span className="text-sm text-stone-400">({shown.length})</span></h2>
        <div className="flex flex-wrap gap-2">
          {KINDS.map(([k, l]) => (
            <button key={k} data-testid={`media-filter-${k}`} onClick={() => setKind(k)} className={chip(kind === k)}>{l}</button>
          ))}
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {["Toutes", ...themes].map((t) => (
          <button key={t} data-testid={`media-theme-filter-${t}`} onClick={() => setTheme(t)} className={chip(theme === t)}>{t}</button>
        ))}
      </div>

      {shown.length ? (
        <div data-testid="media-grid" className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {shown.map((m) => (
            <MediaCard
              key={m.id}
              m={m}
              themes={themes}
              missing={missing.includes(m.id)}
              onPin={() => act(() => api.post(`/admin/media/${m.id}/pin`))}
              onSave={(data) => act(() => api.patch(`/admin/media/${m.id}`, data), "Média mis à jour.")}
              onDelete={() => act(() => api.delete(`/admin/media/${m.id}`), "Média supprimé.")}
            />
          ))}
        </div>
      ) : (
        <p className="mt-5 flex items-center justify-center gap-2 rounded-xl border border-dashed border-stone-300 p-8 text-xs text-stone-400">
          <Images className="h-4 w-4" /> Aucun média dans cette sélection.
        </p>
      )}
    </section>
  );
}
